import React from "react"

import { DEFAULT_PRODUCT_COUNT_PLP } from "@/constants/index"
import Button from "@/components/core/Button/Button"
import { getLoadMoreAnalyticsData } from "@/components/ProductList/v2/ProductListView/Pagination/analytics.js"

const LoadMore = ({
  totalResults = 0,
  staticTexts = {},
  onLoadMore = () => {},
  curRows = 30,
  data = [],
  page = "",
  type = "",
  removeLoadAnimation = false,
}) => {
  const transformClassName = removeLoadAnimation ? "no-transform" : ""
  const handleLoadMore = () => {
    sessionStorage.plpScroll = data[data.length - 1].ctId_s
    onLoadMore()
  }
  return (
    <div
      className="product-listing__row gbh-data-layer"
      data-gbh-data-layer={getLoadMoreAnalyticsData(page, type)}
    >
      {totalResults > DEFAULT_PRODUCT_COUNT_PLP &&
        totalResults > curRows &&
        totalResults > data?.length && (
          <Button
            type="load-more"
            size="small"
            customClass={`product-listing__load-more ${transformClassName}`}
            label={staticTexts.loadMore}
            onClick={handleLoadMore}
            parentClass={"div-wrapper"}
            role={"button"}
          />
        )}
    </div>
  )
}

export default LoadMore
